import React from 'react'
import { Redirect, Route } from 'react-router'
import Cookies from 'js-cookie'

export default function PrivateRoute({ children, permition, ...rest }) {
  const isAuthenticated = Cookies.get('accessToken') ? true : false
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/page-login',
              state: { from: location },
            }}
          />
        )
      }
    />
  )
}
